module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av699-be2f5c7505b796dca405d28806910e1d.jpg";